import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VMain,[_c(VContainer,[_c('h1',{staticClass:"display-1"},[_vm._v("Features")]),_c('div',{staticClass:"text-center"},[_c('about-features',{attrs:{"outlined":_vm.$route.name != 'Features',"text":_vm.$route.name != 'Features'}})],1),_c('div',[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }